import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=c20d6f5e&scoped=true&"
import script from "./tag.vue?vue&type=script&lang=ts&"
export * from "./tag.vue?vue&type=script&lang=ts&"
import style0 from "./tag.vue?vue&type=style&index=0&id=c20d6f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20d6f5e",
  null
  
)

export default component.exports